declare global {
	interface Window {
		dataLayer?: Record<string, unknown>[];
	}
}

const pushEvent = (event: string, params?: Record<string, unknown>) => {
	if (typeof window !== "undefined" && window.dataLayer) {
		window.dataLayer.push({
			event,
			...params,
		});
	}
};

export const trackMySuppliersPageViewed = (): void => {
	pushEvent("my_suppliers_page_viewed");
};

export const trackSupplierDetailViewed = (supplierId: number): void => {
	pushEvent("my_suppliers_detail_viewed", { supplier_id: supplierId });
};

export const trackRatingStarted = (supplierId: number): void => {
	pushEvent("performance_rating_started", { supplier_id: supplierId });
};

export const trackRatingSubmitted = (
	supplierId: number,
	overallScore: number
): void => {
	pushEvent("performance_rating_submitted", {
		supplier_id: supplierId,
		overall_score: overallScore,
	});
};

export const trackPdfExported = (
	type: "supplier" | "rating",
	entityId: number
): void => {
	pushEvent("performance_pdf_exported", {
		export_type: type,
		entity_id: entityId,
	});
};

export const trackSupplierViewedBeforeRfq = (supplierId: number): void => {
	pushEvent("supplier_viewed_before_rfq", { supplier_id: supplierId });
};
